import titleDescriptionForm from './title-description-form'
import titleDescriptionUi from './title-description-ui'

export default {
    titleDescriptionForm,
    titleDescriptionUi
}
